// HTMLMediaElement.play() returns a promise that rejects for entirely expected,
// non-actionable reasons: autoplay policy (NotAllowedError), an unsupported or
// unreachable source (NotSupportedError), or the play being interrupted by a
// pause / new load (AbortError). Left unhandled these surface as unhandled
// promise rejections in Sentry (onunhandledrejection). Swallow them here so
// every call site is guarded consistently.
export const safePlay = (audio: HTMLAudioElement, onError?: (error: unknown) => void): Promise<void> => {
  // play() can return undefined on very old browsers; wrap so .catch is always
  // safe regardless of the return type.
  try {
    return Promise.resolve(audio.play()).catch((error: unknown) => onError?.(error))
  } catch (error) {
    onError?.(error)
    return Promise.resolve()
  }
}
